export default __webpack_public_path__ + "static/media/water2.svg";